import { useStyletron } from '@tigergraph/app-ui-lib/Theme';
import { useMobile } from '@/contexts/mobileContext';
import { Drawer, DrawerBody } from '@/components/Drawer';
import { ReactNode } from 'react';

interface MobileNavigationProps {
  children: ReactNode;
}

export default function MobileNavigation({ children }: MobileNavigationProps) {
  const [css, theme] = useStyletron();
  const { isMobile, isNavigationOpen, setIsNavigationOpen } = useMobile();

  if (!isMobile) {
    return null;
  }

  return (
    <Drawer
      isOpen={isNavigationOpen}
      onClose={() => setIsNavigationOpen(false)}
      anchor="left"
      size="280px"
      showBackdrop={true}
      overrides={{
        Close: {
          style: {
            display: 'none', // Hide the default close button since we have our own header
          },
        },
      }}
    >
      <DrawerBody
        $style={{
          width: '100%',
          paddingLeft: 0,
          paddingRight: 0,
          paddingTop: 0,
          paddingBottom: 0,
          flex: 1,
          overflowY: 'auto',
          backgroundColor: theme.colors['background.secondary'],
        }}
      >
        {children}
      </DrawerBody>
    </Drawer>
  );
}
